const advState= [
  {text: '审核中', value: 1},
  {text: '已通过', value: 2},
  {text: '被拒绝', value: 3},
]
//买家订单总状态
const buyMainStatus=[
  // 【1:待确认】【2：待收款/待支付】【3：代发货】【4：待收货】【5：已完成】
  {text: '待确认', value: 1},
  {text: '待支付', value: 2},
  {text: '待收货', value: 3},
  {text: '待收货', value: 4},
  {text: '已完成', value: 5},
]
//卖家订单总状态
const storeMainStatus=[
  {text: '待确认', value: 1},
  {text: '待收款', value: 2},
  {text: '待发货', value: 3},
  {text: '已完成', value: 4},
  {text: '已完成', value: 5},
]
//总状态下的操作
const operateMainStatus=[
  {text: '去确认', value: 2},
  {text: '待确认', value: 1},
  {text: '去支付', value: 3},
  {text: '去收货', value: 4},
  {text: '去评价', value: 6},
  {text: '', value: 5}
]
//客户订单状态
const orderStatus=[
  {text: '待确认', value: 1},
  {text: '待支付', value: 2},
  {text: '待收货', value: 4},
  {text: '已完成', value: 5},
]
/*//客户在特定订单状态下的操作
const operateStatus=[
  {text: '待支付', value: 1},
  {text: '去支付', value: 2},
  {text: '去收货', value: 4},
  {text: '去评价', value: 5},
]*/
//商家订单状态
/*const merchantStatus=[
  {text: '待确认', value: 1},
  {text: '待收款', value: 2},
  {text: '待发货', value: 3},
  {text: '已完成', value: 4},
]*/
//商家在特定订单状态下的操作
const merchantOperate=[
  {text: '去接单', value: 1},
  {text: '去收款', value: 2},
  {text: '去发货', value: 3},
  {text: '完成交易', value: 4},
  {text: '完成交易', value: 5},
]
//支付类型
const payType=[
  {text:'平台支付',value:1},
  {text:'线下支付',value:2},
]
//支付渠道
const payWay=[
  {text:'支付宝',value:1},
  {text:'微信',value:2},
]
//收货方式
const receiptType=[
  {text:'快递配送',value:1},
  {text:'店内交接',value:2},
]

// 补货订单状态
const replenishmentStatus = [
  {text: '待确认', value: 1},
  {text: '待支付', value: 2},
  {text: '待发货', value: 3},
  {text: '已采用', value: 4},
  {text: '已成交', value: 5},
]

// 补货我收到订单状态
const getreceivedStatus = [
  {text: '待报价', value: 1},
  {text: '待确认', value: 2},
  {text: '被拒绝', value: 3},
  {text: '被采用', value: 4},
  {text: '已成交', value: 5},
]
export {
  advState,
  orderStatus,
  /*operateStatus,*/
  // merchantStatus,
  merchantOperate,
  replenishmentStatus,
  getreceivedStatus,
  payType,
  payWay,
  receiptType,
  // orderMainStatus,
  operateMainStatus,
  buyMainStatus,
  storeMainStatus,
}



// WEBPACK FOOTER //
// ./src/utils/mapper.js